<script setup lang="ts">
import { useElementVisibility } from "@vueuse/core";

const wrapper = ref<HTMLDivElement>();
const targetIsVisible = useElementVisibility(wrapper);
const enableDOM = ref(false);
const stopWatch = watch(targetIsVisible, () => {
  if (targetIsVisible.value && !enableDOM.value) {
    enableDOM.value = true;
    stopWatch();
  }
});
</script>

<template>
  <div ref="wrapper">
    <slot v-if="enableDOM" />
  </div>
</template>

<style scoped lang="postcss"></style>
